@if (state() === 'conflict') {
  <div class="merge-accounts-explanation">
    @if (conflictMessage()) {
      <div class="merge-accounts-conflict-message">{{ conflictMessage() }}</div>
    }

    <p>{{ 'merge_accounts.explanation' | translate }}</p>
  </div>

  @if (error()) {
    <div class="g-form-error">{{ error() }}</div>
  }

  <tc-button
    class="merge-accounts-submit"
    [isLoading]="isLoading()"
    buttonSize="large"
    (click)="mergeInit()"
  >
    {{ 'merge_accounts.verify_and_combine' | translate }}
  </tc-button>

  <button
    class="g-main-link go-back"
    [disabled]="isLoading()"
    (click)="goBack()"
    type="button"
  >
    {{ 'global.back' | translate }}
  </button>
} @else {
  @if (preview()) {
    <!--
      The preview exists only to ask which identifier survives. Everything else it could say describes
      the other account, which the customer has not proven access to at this point in the flow.
    -->
    @for (slot of ambiguousSlots(); track slot.slot) {
      <div class="merge-accounts-choice">
        <div class="merge-accounts-choice-title">
          @if (slot.slot === 'email') {
            {{ 'merge_accounts.choose_email' | translate }}
          } @else {
            {{ 'merge_accounts.choose_phone_number' | translate }}
          }
        </div>

        @for (candidate of slot.candidates; track candidate.owner) {
          <label class="merge-accounts-choice-option">
            <input
              [formControl]="choiceControl(slot)"
              [value]="candidate.owner"
              [name]="slot.slot"
              type="radio"
            >
            <span class="merge-accounts-choice-value">{{ candidate.value }}</span>
            <span class="merge-accounts-choice-owner">
              {{ (isOwnAccount(candidate) ? 'merge_accounts.owner_current' : 'merge_accounts.owner_other') | translate }}
            </span>
          </label>
        }

        @if (isChoiceMissing(slot)) {
          <div class="g-form-error merge-accounts-choice-error">
            {{ (slot.slot === 'email'
              ? 'merge_accounts.choose_email_required'
              : 'merge_accounts.choose_phone_number_required') | translate }}
          </div>
        }
      </div>
    }
  }

  <tc-otp
    [otpRequest]="otpRequest()"
    [otpDigitsFormArray]="form.controls.otpDigits"
    [isLoading]="isLoading()"
    [error]="error()"
    [submitLabel]="'merge_accounts.combine' | translate"
    (submitted)="mergeConfirm()"
    (resendOtp)="mergeInit()"
  />

  <button
    class="g-main-link go-back"
    [disabled]="isLoading()"
    (click)="goBack()"
    type="button"
  >
    {{ 'global.back' | translate }}
  </button>
}
